<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>测试管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div v-show="false"></div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
          <!-- <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div> -->
        </div>
      </div>
      <div id="searchSection">
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.onlineClass_id"
          >
            <option value="">选择班级</option>
            <option
              :value="item.id"
              v-for="item in classData"
              :key="item.id"
            >{{item.title}}</option>
          </select>
          <input
            type="text"
            placeholder="学生账号"
            class="s-input separate"
            v-model="queryInfo.username"
          >
          <input
            type="text"
            placeholder="学生姓名"
            class="s-input separate"
            v-model="queryInfo.name"
          >
          <input
            type="button"
            value="搜索"
            @click="search"
            class="s-btn"
          >
          <div
            class="s-btn export-btn"
            @click="exportData"
          >导出成绩</div>
        </div>
        <div class="search-line clearfix">
        </div>
      </div>
      <div
        id="list"
        style="min-height: 100px;overflow-x: auto;"
      >
        <table
          v-if="tableData.length"
          style="table-layout: fixed;"
        >
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">姓名</th>
              <th class="itemStatus">用户名</th>
              <th class="itemStatus">性别</th>
              <th class="itemStatus">班级</th>
              <th class="itemStatus">预习进度</th>
              <th class="itemStatus">学习进度</th>
              <th class="itemStatus">测试成绩</th>
              <th class="itemStatus">分级</th>
            </tr>
            <tr
              class="item"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <td class="itemStatus">{{item.userProfile.name}}</td>
              <td class="itemStatus">{{item.userProfile.username}}</td>
              <td class="itemStatus">{{parseInt(item.userProfile.gender) == 1?'男':parseInt(item.userProfile.gender) == 1?'女':'未知'}}</td>
              <td class="itemStatus">{{item.onlineClass?item.onlineClass.title:'-'}}</td>
              <td class="itemStatus">{{ previewStudy.length > 0 ? '' + (100 * item.preview_count / previewStudy.length).toFixed(2) + '%' : '-'}}</td>
              <td class="itemStatus">{{ normalStudy.length > 0 ? '' + (100 * item.study_count / normalStudy.length).toFixed(2) + '%' : '-'}}</td>
              <td class="itemStatus">{{item.grade}}</td>
              <td
                class="itemStatus"
                :class="item.grade < 60 ? 'failColor' : item.grade >= 80 ? 'fineColor' : 'goodColor'"
              >{{FunGrade(item.grade)}}</td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
  </div>
</template>

<script>
import outputTable from '../../../assets/basic/outputTable.js'
import Pagination from '../../../components/Pager'

export default {
  name: 'OnlineGrade',
  components: {
    Pagination
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        name: '',
        username: '',
        onlineClass_id: '',
        lessonOnline_id: this.$route.query.id
      },
      classData: [],
      tableData: [],
      tableDataCount: 0,
      studyData: []
    }
  },
  methods: {
    FunGrade(grade) {
      grade = parseInt(grade)
      var txt = ''
      if (grade < 60) {
        txt = '不及格'
      } else if (grade >= 80) {
        txt = '优秀'
      } else if (grade >= 60 && grade < 80) {
        txt = '良好'
      }
      return txt
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    async search() {
      await this.$http.get('/online_student/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取课程列表失败！')
      })
    },
    async exportData() {
      await this.$http.get('/online_student/', {
        params: {
          page: 1,
          size: 100000,
          name: this.queryInfo.name,
          username: this.queryInfo.username,
          onlineClass_id: this.queryInfo.onlineClass_id,
          lessonOnline_id: this.queryInfo.lessonOnline_id
        }
      }).then((data) => {
        const exportData = [{
          name: '姓名',
          username: '用户名',
          gender: '性别',
          classTitle: '班级',
          previewPercent: '预习进度',
          studyPercent: '学习进度',
          grade: '测试成绩',
          gradeDesc: '分级'
        }]
        for (let i = 0; i < data.results.length; i++) {
          exportData.push({
            name: data.results[i].userProfile.name,
            username: data.results[i].userProfile.username,
            gender: parseInt(data.results[i].userProfile.gender) === 1 ? '男' : parseInt(data.results[i].userProfile.gender) === 1 ? '女' : '-',
            classTitle: data.results[i].onlineClass ? data.results[i].onlineClass.title : '-',
            // previewPercent: data.results[i].preview_count,
            // studyPercent: data.results[i].study_count,
            previewPercent: this.previewStudy.length > 0 ? '' + (100 * data.results[i].preview_count / this.previewStudy.length).toFixed(2) + '%' : '-',
            studyPercent: this.normalStudy.length > 0 ? '' + (100 * data.results[i].study_count / this.normalStudy.length).toFixed(2) + '%' : '-',
            grade: data.results[i].grade ? data.results[i].grade : '',
            gradeDesc: data.results[i].grade ? this.FunGrade(data.results[i].grade) : ''
          })
        }
        outputTable(exportData, '成绩.csv')
      }).catch(() => {
        this.$layer.msg('获取课程列表失败！')
      })
    },
    async getClass() {
      await this.$http.get('/online_class/', {
        params: {
          page: 1,
          size: 10000,
          lessonOnline_id: this.lessonInfo.id
        }
      }).then((data) => {
        this.classData = data.results
      })
    },
    async searchStudy () {
      await this.$http.get('/online_study/', {
        params: {
          page: 1,
          size: 10000,
          lessonOnline_id: this.lessonInfo.id
        }
      }).then((data) => {
        this.studyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getClass()
    await this.searchStudy()
    await this.search()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    previewStudy () {
      return this.studyData.filter(m => {
        return m.preview === 0
      })
    },
    normalStudy () {
      return this.studyData.filter(m => {
        return m.preview === 1
      })
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
#searchSection {
  display: flex;
  justify-content: space-between;
}
.itemStatus {
  img {
    width: 120px;
  }
}
.failColor {
  color: #ff0000 !important;
}
.fineColor {
  color: #f19830 !important;
}
.goodColor {
  color: #2e8b57 !important;
}
.fileName span {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
#searchSection .export-btn {
  background: orange;
  border: none;
  position: absolute;
  right: 80px;
}
</style>
